import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab, TabList, } from "@fluentui/react-components";
import { CalendarMonthRegular, PersonRegular, PeopleRegular, PeopleTeamRegular, SettingsRegular, } from "@fluentui/react-icons";
import { useRole } from "../../context/RoleContext";
// Roles minimum pour acceder a chaque vue
const VIEW_ACCESS = {
    approbations: ["Admin", "SuperUser", "RH", "Manager"],
    planning: ["Admin", "SuperUser", "RH", "Manager"],
    salaries: ["Admin", "SuperUser", "RH", "Manager"],
    services: ["Admin", "SuperUser", "RH", "Manager"],
    approbateurs: ["Admin", "SuperUser"],
    administration: ["Admin"],
};
const navItems = [
    { key: "planning", label: "Planning & Absences", icon: _jsx(CalendarMonthRegular, {}) },
    { key: "salaries", label: "Salariés", icon: _jsx(PersonRegular, {}) },
    { key: "services", label: "Services", icon: _jsx(PeopleTeamRegular, {}) },
    { key: "approbateurs", label: "Approbateurs", icon: _jsx(PeopleRegular, {}) },
    { key: "administration", label: "Administration", icon: _jsx(SettingsRegular, {}) },
];
export const SideNav = ({ activeView, onNavigate }) => {
    const { role } = useRole();
    const visibleItems = navItems.filter((item) => VIEW_ACCESS[item.key].includes(role));
    return (_jsxs("nav", { style: {
            width: "200px",
            minHeight: "100vh",
            borderRight: "1px solid var(--colorNeutralStroke1, #e0e0e0)",
            padding: "16px 0",
            backgroundColor: "var(--colorNeutralBackground2, #fafafa)",
        }, "aria-label": "Navigation principale", children: [_jsx("div", { style: { padding: "0 16px 16px", fontWeight: 700, fontSize: "16px" }, children: "Portail RH" }), _jsx(TabList, { vertical: true, selectedValue: activeView, onTabSelect: (_, data) => onNavigate(data.value), style: { width: "100%" }, children: visibleItems.map((item) => (_jsx(Tab, { value: item.key, icon: item.icon, "data-tour": `nav-${item.key}`, children: item.label }, item.key))) })] }));
};
export { VIEW_ACCESS };
